module.exports = __webpack_public_path__ + "assets/chevron-down.8a25f113.svg";